import { animate, style, transition, trigger } from '@angular/animations';

export function fallIn() {
  return trigger('fallIn', [
    transition(':enter', [
      style({ opacity: '0', transform: 'translateY(40px)' }),
      animate(
        '.4s .2s ease-in-out',
        style({ opacity: '1', transform: 'translateY(0)' })
      ),
    ]),
    transition(':leave', [
      style({ opacity: '1', transform: 'translateX(0)' }),
      animate(
        '.3s ease-in-out',
        style({ opacity: '0', transform: 'translateX(-200px)' })
      ),
    ]),
  ]);
}
